import { BuzzerMode } from '../hooks/useBuzzerSignalR';

export const BUZZER_MODES: BuzzerMode[] = ['sequential', 'lockout'];

export const BUZZER_MODE_LABELS: Record<BuzzerMode, { title: string; hint: string }> = {
  sequential: {
    title: 'Sıra',
    hint: 'Hamı sıxa bilər, sıxmalar sıra ilə yazılır.',
  },
  lockout: {
    title: 'Kilid',
    hint: 'İlk sıxan düyməni kilidləyir, qalan sıxmalar moderator sıfırlayana qədər nəzərə alınmır.',
  },
};

export const BUZZER_SOUND_LABELS = {
  muteOn: 'Səsi söndür',
  muteOff: 'Səsi aç',
};
